import * as classNames from 'classnames';
import isEqual from 'lodash-es/isEqual';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./Toggle.css');

// Types
export type ToggleValue = 'unknown' | 'left' | 'right';

// Interfaces
export interface IToggleSide {
    value: any;
    label?: string;
    type: 'default' | 'important' | 'success';
}

// Props
interface IToggleProps {
    onChange?: (newValue: IToggleSide | null) => void;
    left?: IToggleSide;
    right?: IToggleSide;
    value: any;
}

// Component
@observer
export class Toggle extends React.Component<IToggleProps, {}> {
    static get defaultProps(): IToggleProps {
        return {
            onChange: null,
            left: {
                value: false,
                label: null,
                type: 'default',
            },
            right: {
                value: true,
                label: null,
                type: 'default',
            },
            value: null,
        };
    }

    constructor(props: IToggleProps) {
        super(props);

        setTimeout(() => {
            this.calculateSliderPositionAndSize();
        }, 128);
    }

    @observable private sizing: { left: number; right: number } = {
        left: 0,
        right: 0,
    };

    @computed private get value(): ToggleValue {
        return this.props.value !== null
            ? this.props.value === this.props.left.value
                ? 'left'
                : this.props.value === this.props.right.value
                ? 'right'
                : 'unknown'
            : 'unknown';
    }

    public componentDidUpdate(prevProps: IToggleProps) {
        if (
            !isEqual(this.props.left, prevProps.left) ||
            !isEqual(this.props.right, prevProps.right)
        ) {
            this.calculateSliderPositionAndSize();
        }
    }

    public render() {
        return (
            <button
                onClick={this.handleToggle}
                className={classNames(s.toggle, {
                    [s.isUnknown]: this.value === 'unknown',
                    [s.isLeft]: this.value === 'left',
                    [s.isRight]: this.value === 'right',
                })}
            >
                <p
                    ref={this.referenceLeftLabel}
                    className={classNames(s.left, {
                        [s.important]:
                            typeof this.props.left.type !== 'undefined' &&
                            this.props.left.type === 'important',
                        [s.success]:
                            typeof this.props.left.type !== 'undefined' &&
                            this.props.left.type === 'success',
                    })}
                >
                    <span>
                        {typeof this.props.left.label !== 'undefined' &&
                        this.props.left.label
                            ? this.props.left.label
                            : ''}
                    </span>
                </p>
                <p
                    ref={this.referenceRightLabel}
                    className={classNames(s.right, {
                        [s.important]:
                            typeof this.props.right.type !== 'undefined' &&
                            this.props.right.type === 'important',
                        [s.success]:
                            typeof this.props.right.type !== 'undefined' &&
                            this.props.right.type === 'success',
                    })}
                >
                    <span>
                        {typeof this.props.right.label !== 'undefined' &&
                        this.props.right.label
                            ? this.props.right.label
                            : ''}
                    </span>
                </p>

                <div
                    className={s.slider}
                    style={{
                        opacity:
                            (this.sizing.left !== 0 &&
                                this.sizing.right !== 0) ||
                            this.value === 'unknown'
                                ? 1
                                : 0,
                        left:
                            this.value === 'unknown'
                                ? '0px'
                                : this.value === 'right'
                                ? '0px'
                                : this.sizing.left + 'px',
                        width:
                            this.value === 'unknown'
                                ? this.sizing.left + this.sizing.right + 'px'
                                : this.value === 'right'
                                ? this.sizing.left + 'px'
                                : this.sizing.right + 'px',
                    }}
                >
                    <p>{this.value === 'unknown' ? 'Answer' : ''}</p>
                    <span
                        className={classNames(s.ridge, s.ridgeLeft, {
                            [s.hidden]: this.value === 'unknown',
                        })}
                    />
                    <span
                        className={classNames(s.ridge, {
                            [s.hidden]: this.value === 'unknown',
                        })}
                    />
                    <span
                        className={classNames(s.ridge, s.ridgeRight, {
                            [s.hidden]: this.value === 'unknown',
                        })}
                    />
                </div>
            </button>
        );
    }

    private leftLabel: HTMLParagraphElement = null;
    private rightLabel: HTMLParagraphElement = null;
    private referenceLeftLabel = (ref: HTMLParagraphElement) =>
        (this.leftLabel = ref);
    private referenceRightLabel = (ref: HTMLParagraphElement) =>
        (this.rightLabel = ref);

    private handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.calculateSliderPositionAndSize();

        if (this.props.onChange) {
            this.props.onChange(
                this.value === 'unknown' || this.value === 'right'
                    ? this.props.left
                    : this.value === 'left'
                    ? this.props.right
                    : null
            );
        }
    };

    private calculateSliderPositionAndSize = () => {
        this.sizing = {
            left: this.leftLabel ? this.leftLabel.offsetWidth : 0,
            right: this.rightLabel ? this.rightLabel.offsetWidth : 0,
        };
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/Toggle.tsx